import QRCode from "qrcode.react";

const BadgeBarcode = ({
  payload,
  name,
}: {
  payload: string;
  name?: string | null;
}) => {
  return (
    <div className="Barcode BadgeBarcode">
      <p className="Barcode__label">{name}</p>
      <div className="Barcode__qr">
        <QRCode
          value={`login-${payload}`}
          size={58}
          bgColor={"#ffffff"}
          fgColor={"var(--black)"}
          level={"M"}
          includeMargin={false}
          renderAs={"svg"}
        />
      </div>
    </div>
  );
};

export default BadgeBarcode;
